export default __webpack_public_path__ + "static/media/thumbnail.cb66573a.png";